(function($) {
    $(window).on('load', function() {

        $('.facebook-login').on('click', function () {

            FB.login(function(response) {
                console.log(response)
                if (response.status === 'connected') {
                    if (response.authResponse.grantedScopes == 'email,public_profile') {
                        facebookLogin();
                    } else {

                    }
                }

            }, {scope: 'email', auth_type: 'rerequest', return_scopes: true});
        });

        var googleUser = {};
        // var startApp = function() {
        //     gapi.load('auth2', function(){
        //         auth2 = gapi.auth2.init({
        //             client_id: '1033625120424-aa8266uorb0o3cd81tdf07linjj54jju.apps.googleusercontent.com',
        //             cookiepolicy: 'single_host_origin'
        //         });
        //         attachSignin($('.google-login')[0]);
        //     });
        // };

        // startApp();

        function attachSignin(element) {
            auth2.attachClickHandler(element, {},
                function(googleUser) {
                    console.log(googleUser)
                    googleLogin(googleUser);
                }, function(error) {
                    console.log(error)
                });
        }

    });

    $(window).on('scroll', function () {

    });

    $(window).on('resize', function () {

    });

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    function facebookLogin() {
        FB.api('/me?fields=email,first_name,last_name', function(response) {
            var email = response.email;
            var id = response.id;
            var first_name = response.first_name;
            var last_name = response.last_name;

            var data = {
                'action' : 'login_social',
                'type' : 'facebook',
                'email' : email,
                'id' : id,
                'first_name' : first_name,
                'last_name' : last_name,
            };
            $.get(localize_object.ajaxurl, data, function(response){
                if (response.success) {
                    window.location.reload();
                } else {
                    // $('.modal-login .modal-content').removeClass('loader');
                    // $('.login-content .facebook-error').html(response.data.error).show();
                }
            });
        });
    }

    function googleLogin(googleUser) {
        console.log(googleUser)
        var profile = googleUser.getBasicProfile();
        var email = profile.getEmail();
        var id = profile.getId();

        console.log('googlelogin')

        var data = {
            'action' : 'login_social',
            'type' : 'google',
            'email' : email,
            'id' : id
        };
        $.get(localize_object.ajaxurl, data, function(response){
            if (response.success) {
                window.location.reload()
            } else {

            }
        });
    }

})( jQuery );